var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaaInitial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x84\xB6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M36.65,49.58s-3.47-2.18-3.07-2.74,2.35-3.72,2.83-3.64,3.64,2,3.8,2.83-2.1,3.39-2.42,3.8C37.38,50.07,36.65,49.58,36.65,49.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    strokeWidth: 7,
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    d: "M40.38,46.61h-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M16.3,35.6,41,35.2s1-3.8-3.1-8.2l2.4-4.5s4.1,5.8,2.7,18.2H16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    strokeWidth: 7,
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    d: "M39.4,22.9s3.54,7.93,2.39,15.63L16,38.3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaaInitial);
export default __webpack_public_path__ + "static/media/baa-initial.ca841ecc55e7cc4769d97021de187fd1.svg";
export { ForwardRef as ReactComponent };